import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';

import styles from './ContemporaryLandingTextHeaderModule.scss';

const ContemporaryLandingTextHeaderModuleComponent = ({ contemporaryLandingHeader }) => {
    if (!contemporaryLandingHeader) {
        return null;
    }

    const { text } = contemporaryLandingHeader;

    return <div className={styles.header}>{text}</div>;
};

export const ContemporaryLandingTextHeaderModule = createFragmentContainer(
    ContemporaryLandingTextHeaderModuleComponent,
    {
        contemporaryLandingHeader: graphql`
            fragment ContemporaryLandingTextHeaderModule_contemporaryLandingHeader on ContemporaryLandingHeader {
                ... on ContemporaryLandingHeader {
                    text
                }
            }
        `,
    }
);

ContemporaryLandingTextHeaderModule.propTypes = {
    ContemporaryLandingSplashHeader: PropTypes.object,
};
